export const FETCH_PENSION_MASTER_DDL = "FETCH_PENSION_MASTER_DDL";
export const CREATE_PENSION_MASTER = "CREATE_PENSION_MASTER";
export const EDIT_PENSION_MASTER = "EDIT_PENSION_MASTER";
export const DELETE_PENSION_MASTER = "DELETE_PENSION_MASTER";
